export default "__VITE_ASSET__CqqksYqv__"